import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

export type Database = {
  public: {
    Tables: {
      profiles: {
        Row: {
          id: string
          email: string
          nickname: string | null
          avatar_url: string | null
          phone: string | null
          bio: string | null
          created_at: string
          updated_at: string
          is_admin: boolean
        }
        Insert: {
          id: string
          email: string
          nickname?: string | null
          avatar_url?: string | null
          phone?: string | null
          bio?: string | null
          is_admin?: boolean
        }
        Update: {
          nickname?: string | null
          avatar_url?: string | null
          phone?: string | null
          bio?: string | null
        }
      }
      courts: {
        Row: {
          id: string
          name: string
          location: string
          district: string
          address: string
          contact_phone: string | null
          contact_email: string | null
          description: string | null
          amenities: string[] | null
          photos: string[] | null
          latitude: number | null
          longitude: number | null
          hourly_rate: number | null
          operating_hours: any | null
          created_at: string
          updated_at: string
        }
      }
      sessions: {
        Row: {
          id: string
          title: string
          description: string | null
          court_id: string | null
          creator_id: string | null
          session_date: string
          start_time: string
          end_time: string
          max_participants: number
          current_participants: number
          skill_level: string | null
          price: number
          status: string
          created_at: string
          updated_at: string
        }
      }
      session_bookings: {
        Row: {
          id: string
          session_id: string | null
          user_id: string | null
          booking_status: string
          booked_at: string
        }
      }
      learning_resources: {
        Row: {
          id: string
          title: string
          description: string | null
          content: string | null
          resource_type: string | null
          skill_level: string | null
          video_url: string | null
          thumbnail_url: string | null
          author_id: string | null
          is_featured: boolean
          view_count: number
          created_at: string
          updated_at: string
        }
      }
      matches: {
        Row: {
          id: string
          player1_id: string | null
          player2_id: string | null
          player1_name: string
          player2_name: string
          player1_score: number
          player2_score: number
          match_date: string
          court_id: string | null
          match_duration: number | null
          game_scores: any | null
          winner_id: string | null
          match_type: string
          created_at: string
        }
      }
      direct_messages: {
        Row: {
          id: string
          sender_id: string | null
          recipient_id: string | null
          message: string
          is_read: boolean
          created_at: string
        }
      }
    }
  }
}